import {api} from './configs/axiosConfigs'
import {defineCancelApiObject} from './configs/axiosUtils'

export const UserAPI = {
    getAll: async function (filters, cancel = false) {
        const response = await api.request({
            url: '/users',
            method: 'GET',
            params: filters,
            signal: cancel ? cancelApiObject[this.getAll.name].handleRequestCancellation().signal : undefined,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`
            },
        })

        return response.data
    },
//     update user
    update: async function (id, data) {
        const response = await api.request({
            url: `/users/${id}`,
            method: 'PUT',
            data: data,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`
            },
        })

        return response.data
    },
//     create user
    create: async function (data) {
        const response = await api.request({
            url: `/users`,
            method: 'POST',
            data: data,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`
            },
        })
        return response.data
    },

    delete: async function (id) {
        const response = await api.request({
            url: `/users/${id}`,
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`
            },
        })

        return response.data
    },
}

const cancelApiObject = defineCancelApiObject(UserAPI)